import React from 'react';
import { Hero } from '../components/Hero';
import { TechnologyPillars } from '../components/TechnologyPillars';
import { ProductCard } from '../components/ProductCard';
import { Footer } from '../components/Footer';
import { MoreHorizontal, Mail } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-black text-white selection:bg-gray-700 selection:text-white" data-id="element-70">
      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-black/80 backdrop-blur-md" data-id="element-71">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8" data-id="element-72">
          <div className="flex items-center gap-1 text-xl font-bold tracking-tight text-white" data-id="element-73">
            AVL Group
          </div>
          <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-300" data-id="element-74">
            <a href="#solutions" className="hover:text-white transition-colors" data-id="element-75">
              Solutions
            </a>
            <a href="#about" className="hover:text-white transition-colors" data-id="element-76">
              About
            </a>
            <a href="#contact" className="hover:text-white transition-colors" data-id="element-77">
              Contact
            </a>
          </div>
        </div>
      </nav>

      <main data-id="element-78">
        <Hero data-id="element-79" />

        {/* Solutions Section */}
        <section id="solutions" className="py-24 px-6 lg:px-8 relative bg-gradient-to-b from-[#0a0a0a] to-black" data-id="element-80">
          <div className="mx-auto max-w-7xl relative z-10" data-id="element-81">
            <div className="mb-4 md:flex md:items-end md:justify-between" data-id="element-82">
              <div className="max-w-2xl" data-id="element-83">
                <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-4" data-id="element-84">
                  Our Solutions
                </h2>
              </div>
            </div>

            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-85">
              <ProductCard title="AI-Market" description="Generate videos and images using top AI models in one unified interface. Access leading neural networks including Sora, Veo, Flux, and Imagen from anywhere and without paying monthly subscriptions." icon={<svg className="h-10 w-10" viewBox="0 0 844 709" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-87">
                    <path d="M207.405 259.5C208.741 256.436 211.551 254.488 214.634 254.488H370.619C376.527 254.488 380.408 261.292 377.848 267.163L171.245 703.146C169.909 706.21 167.099 708.159 164.016 708.159H8.03068C2.12266 708.159 -1.75784 701.355 0.801674 695.484L207.405 259.5Z" fill="white" data-id="element-88" />
                    <path d="M314.496 12.6522C311.947 6.7855 315.833 0 321.742 0H477.951C481.044 0 483.862 1.95478 485.197 5.02577L843.204 696.095C845.754 701.961 841.868 708.747 835.959 708.747H679.75C676.657 708.747 673.839 706.792 672.504 703.721L314.496 12.6522Z" fill="white" fillOpacity="0.5" data-id="element-89" />
                    <path d="M356.891 548.015C351.852 542.377 355.572 533 362.847 533H524.36C526.608 533 528.759 533.985 530.316 535.728L686.046 693.732C691.085 699.371 687.365 708.747 680.09 708.747H518.577C516.329 708.747 514.178 707.762 512.621 706.019L356.891 548.015Z" fill="white" fillOpacity="0.7" data-id="element-90" />
                  </svg>} features={['Free credits upon registration', 'No monthly subscription required', 'Access to to all SOTA generation models from single interface.']} buttonText="Try AI-Market" buttonUrl="https://aimarket.tech" data-id="element-86" />

              <ProductCard title="SpectrAI" description="Analyze videos of any length using only natural language. Universal video agent that replaces computer vision engineers — just ask and get the required results." icon={<MoreHorizontal className="h-10 w-10 text-white" data-id="element-92" />} features={['Video analysis using natural language', 'Works with videos of any length', 'No technical expertise required']} buttonText="Try SpectrAI" buttonUrl="https://spectrai.ru" data-id="element-91" />

              <div className="relative" data-id="element-93">
                <div className="absolute top-4 right-4 z-10" data-id="element-94">
                  <span className="inline-flex items-center rounded-full bg-gradient-to-r from-gray-700 to-gray-600 px-3 py-1 text-xs font-semibold text-white" data-id="element-95">
                    Coming Soon
                  </span>
                </div>
                <ProductCard title="WeaveAd" description="Merge advertising short videos into any content using only natural language. Your universal video ad agent—just describe the placement and let AI handle the technical execution." icon={<MoreHorizontal className="h-10 w-10 text-white" data-id="element-97" />} features={['Find optimal placement with AI', 'Generate multiple ad suggestions', 'Add rich product context', 'Works with any video format', 'Zero editing skills needed']} buttonText="Coming Soon..." buttonUrl="https://weavead.tech" data-id="element-96" />
              </div>
            </div>
          </div>
        </section>

        {/* About Us Section */}
        <section id="about" className="py-24 px-6 lg:px-8 bg-gradient-to-b from-black to-[#0a0a0a]" data-id="element-98">
          <div className="mx-auto max-w-4xl" data-id="element-99">
            <div className="text-center mb-12" data-id="element-100">
              <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-101">
                About Us
              </h2>
              <div className="h-1 w-16 bg-gradient-to-r from-gray-700 to-gray-500 mx-auto" data-id="element-102"></div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#1a1a1a] to-black p-8 md:p-12" data-id="element-103">
              <div className="space-y-6 text-lg leading-relaxed" data-id="element-104">
                <p className="text-gray-300" data-id="element-105">
                  AVL Group is dedicated to bridging the gap between latest AI
                  research and real-world applications. We adapt, optimize, and
                  refine original AI algorithms to make their power more
                  available and practical for a broad audience.
                </p>

                <p className="text-gray-400" data-id="element-106">
                  We possess deep expertise across the three key AI modalities:{' '}
                  <span className="text-white font-medium" data-id="element-107">
                    video, audio, and language
                  </span>
                  . Our focus extends beyond individual capabilities to their
                  integration, creating multimodal solutions that combine these
                  elements for the most intuitive and effective user experience.
                  We believe the future lies in this seamless fusion, and we
                  build the tools to make it a reality.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="contact" className="py-24 px-6 lg:px-8 bg-gradient-to-b from-[#0a0a0a] to-black" data-id="element-108">
          <div className="mx-auto max-w-7xl rounded-3xl border border-white/10 bg-gradient-to-br from-[#1a1a1a] to-black p-8 md:p-16 text-center relative overflow-hidden" data-id="element-109">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-110"></div>
            <div className="relative z-10" data-id="element-111">
              <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-112">
                Have any questions about our solutions?
              </h2>
              <p className="mx-auto max-w-2xl text-lg text-gray-400 mb-10" data-id="element-113">
                Get in touch with our team to learn more about how our AI
                solutions can help your business.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-114">

                 <a href="mailto:contact@avlgroup.com" className="inline-flex items-center gap-2 rounded-lg bg-white px-8 py-3.5 text-sm font-semibold text-black transition-all hover:bg-gray-200" data-id="element-115">
                <Mail className="h-4 w-4" data-id="element-116" />
                Contact Us
              </a>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer data-id="element-117" />
    </div>;
}
function ArrowRight({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-118">
      <path d="M5 12h14" data-id="element-119" />
      <path d="m12 5 7 7-7 7" data-id="element-120" />
    </svg>;
}